export default __webpack_public_path__ + "static/media/boxlogoblue.945f48c2.svg";